// Added for Button

import * as React from "react";

function SvgButtonRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#button-right_svg__filter0_d)">
        <circle cx={14.5} cy={12.5} r={12.5} fill="#fff" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.586 14H8v-2h8.586l-3.293-3.293 1.414-1.414L20.414 13l-5.707 5.707-1.414-1.414L16.586 14z"
        fill="currentColor"
      />
      <defs>
        <filter
          id="button-right_svg__filter0_d"
          x={0}
          y={0}
          width={29}
          height={29}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgButtonRight;
